/* esm.sh - applesauce-common@5.2.0/dist/operations/calendar */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/calendar.mjs";
